<div class="body-tab">
  <!--<div class="menu-modal" *ngIf="tId!=null">
    <div class="menu-left">
      <a class="" (click)="DanhSachLopHoc1()"><em class="fa-13x mr-2 fas fa-user-times"></em> {{'Xóa khỏi lớp' | translate}}</a> |
      <a class="" (click)="DanhSachLopHoc1()"><em class="fa-13x mr-2 fab fa-hubspot"></em> {{'Chuyển lớp' | translate}}</a> |
      <a class="" (click)="DangKyHoc1()"><em class="fa-13x mr-2 far fa-registered"></em> {{'Học phí' | translate}}</a> |
      <a class="" (click)="PhatDungCu1()"><em class="fa-13x mr-2 fab fa-dropbox"></em> {{'Phát dụng cụ' | translate}}</a>
    </div>
    <div class="menu-right">
      <a><span class="sttitle">{{'Tích lũy' | translate}}:</span><span class="stien">{{hosoSelect.TichLuy | number}}</span></a> |
      <a><span class="sttitle">{{'Tổng nợ' | translate}}:</span><span class="stien">{{hosoSelect.TongNo | number}}</span></a> |
      <a><span class="sttitle">{{'Số tiền còn lại' | translate}}:</span><span class="stien">{{hosoSelect.TienThua | number}}</span></a>
    </div>
  </div>-->
  <div class="row-information">
    <label class="title-information ng-binding">Thông tin chung </label>
    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Tài khoản/CCCD' | translate}}<span class="cred">(*)</span></label>
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="1" class="form-control" [disabled]="hosoSelect.Id>0"  placeholder="Tài khoản hoặc CCCD (Không nhập hệ thống tự sinh)" [(ngModel)]="hosoSelect.TaiKhoan">
      </div>
      <label class="col-xl-2 col-form-label">{{'Mật khẩu' | translate}}</label> 
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="2" *ngIf="hosoSelect.Id==null || hosoSelect.Id==0" class="form-control" placeholder="" [(ngModel)]="hosoSelect.MatKhau">
        <input type="password" tabindex="3" [disabled]="true" *ngIf="hosoSelect.Id>0" class="form-control" placeholder="" [(ngModel)]="hosoSelect.MatKhau">
      </div>
    </div>
    
    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Họ và tên' | translate}}<span class="cred">(*)</span> </label>
      <div class="col-xl-2 in-place">
        <input type="text" tabindex="4" class="form-control" placeholder="" [(ngModel)]="hosoSelect.HoVaTen" (blur)="onNameBlur()">
      </div>
      <div class="col-xl-2 in-place">
        <input type="text" tabindex="5" class="form-control" placeholder="Biệt danh" [(ngModel)]="hosoSelect.TenGoiKhac">
      </div>
      <label class="col-xl-2 col-form-label">{{'Ngày sinh' | translate}}</label>
      <div class="col-xl-2" style="display: flex; justify-content: space-between;">
        <kendo-dateinput tabindex="7" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="hosoSelect.NgaySinh"></kendo-dateinput>
      </div>
      <div class="col-xl-2">
        <ng-select [openOnEnter]="false"
                   [items]="inputgioitinhs"
                   bindValue="Id"
                   bindLabel="Name"
                   tabindex="8"
                   notFoundText="Không có dữ liệu"
                   placeholder="Giới tính"
                   style="width:100px"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.GioiTinh">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Name}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Địa chỉ' | translate}} </label>
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="11" class="form-control" placeholder="" [(ngModel)]="hosoSelect.NguyenQuan">
      </div>
      <label class="col-xl-2 col-form-label">{{'Email' | translate}} </label>
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="12" class="form-control" placeholder="" [(ngModel)]="hosoSelect.Email">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Điện thoại' | translate}} </label>
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="13" class="form-control" placeholder="" [(ngModel)]="hosoSelect.DienThoaiDiDong">
      </div>
      <label class="col-xl-2 col-form-label">{{'Nguyện vọng' | translate}} </label>
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="15" class="form-control" placeholder="" [(ngModel)]="hosoSelect.NguyenVong">
      </div>
    </div>
    <div class="form-group row">

      <label class="col-xl-2 col-form-label">{{'Nguồn khách' | translate}} </label>
      <div class="col-xl-4">
        <ng-select [openOnEnter]="false"
                   [items]="inputkenhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="16"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.NguonKenh">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="col-xl-2 col-form-label">{{'Trường đang học' | translate}} </label>
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="17" class="form-control" placeholder="" [(ngModel)]="hosoSelect.TruongHoc">
      </div>
    </div>
   
  </div>
  <div class="row-information">
    <label class="title-information ng-binding">Thông tin liên hệ </label>
    <div class="parent-info-container">
      <div class="info-section">
        <h6>Thông tin mẹ</h6>
        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Tên mẹ' | translate}}</label>
          <div class="col-xl-4 in-place">
            <input type="text" tabindex="19" class="form-control" placeholder="" [(ngModel)]="hosoSelect.NameParent">
          </div>
          <label class="col-xl-2 col-form-label">{{'Điện thoại' | translate}}</label>
          <div class="col-xl-4 in-place">
            <input type="text" tabindex="20" class="form-control" placeholder="" [(ngModel)]="hosoSelect.PhoneParent">
            <button class="zalo-button">Zalo</button>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-2 col-form-label">Facebook</label>
          <div class="col-xl-10 in-place">
            <input type="text" tabindex="21" class="form-control" placeholder="" [(ngModel)]="hosoSelect.FacebookParent">
            <button class="facebook-button">Fb</button>
          </div>
        </div>

      </div>
      <div class="info-section">
        <h6>Thông tin bố</h6>
        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Tên bố' | translate}}</label>
          <div class="col-xl-4 in-place">
            <input type="text" tabindex="22" class="form-control" placeholder="" [(ngModel)]="hosoSelect.NameDad">
          </div>
          <label class="col-xl-2 col-form-label">{{'Điện thoại' | translate}}</label>
          <div class="col-xl-4 in-place">
            <input type="text" tabindex="23" class="form-control" placeholder="" [(ngModel)]="hosoSelect.PhoneDad">
            <button class="zalo-button">Zalo</button>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-2 col-form-label">Facebook</label>
          <div class="col-xl-10 in-place">
            <input type="text" tabindex="24" class="form-control" placeholder="" [(ngModel)]="hosoSelect.FacebookDad">
            <button class="facebook-button">Fb</button>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div class="row-information">
    <label class="title-information ng-binding">Thông tin khác </label>
    
    <div class="form-group row">

      <label class="col-xl-2 col-form-label">{{'Lớp' | translate}}<span class="cred">(*)</span> </label>
      <div class="col-xl-4">
        <!--[disabled]="hosoSelect.Id>0"-->
        <ng-select #slLop
                   class="twcollong"
                   [tabIndex]="26"
                   [multiple]="true"
                   [openOnEnter]="false"
                   [items]="dslops"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="hosoSelect.DSLop">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="col-xl-2 col-form-label">{{'Phụ trách' | translate}} </label>
      <div class="col-xl-2">
        <ng-select #slPhuTrach
                   class="twcollong"
                   [tabIndex]="27"
                   [openOnEnter]="false"
                   [items]="inputGiangViens"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.IdConsult">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Thời hạn từ/đến' | translate}}</label>
      <div class="col-xl-4 in-place">
        <kendo-dateinput tabindex="28" style="width:48%;" [format]="'dd/MM/yyyy'" [(value)]="hosoSelect.ElearningBegin"></kendo-dateinput>

        <kendo-dateinput tabindex="29" style="width:48%;float:right !important" [format]="'dd/MM/yyyy'" [(value)]="hosoSelect.ElearningEnd"></kendo-dateinput>
      </div>
      <label class="col-xl-2 col-form-label">{{'Ghi chú' | translate}}</label>
      <div class="col-xl-4 in-place">
        <input type="text" tabindex="30" class="form-control" placeholder="" [(ngModel)]="hosoSelect.Notes">
      </div>
    </div>



    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Ngày tạo' | translate}}/{{'Người tạo' | translate}}</label>
      <div class="col-xl-2 in-place">
        <span>{{hosoSelect.Created | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
      </div>
      <div class="col-xl-2 in-place">
        <span>{{hosoSelect.CreatedBy}}</span>
      </div>
      <label class="col-xl-2 col-form-label">{{'Ngày sửa' | translate}}/{{'Người sửa' | translate}}</label>
      <div class="col-xl-2 in-place">
        <span>{{hosoSelect.Modified | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
      </div>
      <div class="col-xl-2 in-place">
        <span>{{hosoSelect.ModifiedBy}}</span>
      </div>
    </div>





  </div>
  <div class="modal-footer" style="display: flex;justify-content: space-between;">
    <div style="display:flex;">
      <!--<div class="checkbox c-checkbox">
        <label>
          <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
          <span class="fa fa-check"></span> {{'Không sử dụng' | translate}}
        </label>
      </div>-->
    </div>

    <div class="">
      <button style="float:left !important" *ngIf="!(quyen_sua==false && hosoSelect.Id!=null)" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
      <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    </div>

  </div>
  <div id='target' class="control-section">
    <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
                [target]='target' [width]='dialogWidth'>
      <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                       [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                       [contextMenuSettings]='contextMenuSettings'
                       [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)" [showThumbnail]="false">
      </ejs-filemanager>
    </ejs-dialog>
  </div>

</div>
<bs-modal #mdDanhSachLichHoc class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'">
  <div class="modal-header">
    <h4 class="modal-title">{{'Danh sách lịch học' | translate}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDanhSachLichHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-danhsachlichhocedit #dtedslichhocedit (savect)="save_danhsachlichhoc($event)"></app-daotao-danhsachlichhocedit>
  </bs-modal-body>
</bs-modal>


<bs-modal #modal class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{'Danh sách tài khoản' | translate}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="modal.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chontaikhoanedit #dteChonTaiKhoan (savect)="savetaikhoan($event)"></app-tonghop-chontaikhoanedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdDanhSachLopHoc1 class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title" style="width: 400px">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDanhSachLopHoc1.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-danhsachlophocedit #danhsachlophocedit1 (save)="saveModal_DoiMatKhau1($event)"></app-daotao-danhsachlophocedit>
  </bs-modal-body>
</bs-modal>
<bs-modal #mdDangKyHoc1 class="modal fade show in" [cssClass]="'modal90'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title" style="width: 400px">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDangKyHoc1.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-dangkyhocedit #dangkyhocedit1 (save)="saveModal_DoiMatKhau1($event)"></app-daotao-dangkyhocedit>
  </bs-modal-body>
</bs-modal>
<bs-modal #mdPhatDungCu1 class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title" style="width: 400px">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdPhatDungCu1.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-danhsachphatdungcuedit #phatdungcuedit1 (save)="saveModal_DoiMatKhau1($event)"></app-daotao-danhsachphatdungcuedit>
  </bs-modal-body>
</bs-modal>
